import React from 'react';
import MobileDetect from 'mobile-detect';
import LazyLoad from 'react-lazyload';
import i18n from '../../i18n';

const md = new MobileDetect(window.navigator.userAgent);
const namespaceMap = {
    'image-proofing': 'imageProofing',
    'video-proofing': 'videoProofing',
    'document-proofing': 'documentProofing',
    'boards': 'boards',
    'report': 'report',
    'gantt-chart': 'gantt',
    'custom-workflow': 'customWorkflow',
    'request-forms': 'requestForms',
    'calendar': 'calendar'
}

class MobileWrapper extends React.Component {
    state = {
        isGif: true,
        isEuVisitorLoaded: false
    }

    componentDidMount() {
        this.addListener()
    }

    addListener() {
        window.addEventListener('gdprCookieChanged', (event) => this.onUpdateConsentDecision(event), false);
    }

    onUpdateConsentDecision(event) {
        try {
            const eventData = this.readConsentFromCookie(event.detail.cookieKey);
            this.validateGDPR(eventData);
        }
        catch (e) {
            console.log(e);
        }
    }

    readConsentFromCookie(cookieKey) {
        const cookieValue = this.getCookieByName(cookieKey);

        return cookieValue.split('.').map(Number);
    }

    getCookieByName(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    validateGDPR(state) {
        const functionalCategoryId = 2;

        if (state.indexOf(functionalCategoryId) > -1) {
            this.updateComponentState(false);
        }
    }

    updateComponentState(isGif) {
        this.setState({
            isGif: isGif
        });
    }

    getInternetExplorerVersion() {
        var rv = -1
        var ua, re
        if (navigator.appName === 'Microsoft Internet Explorer') {
            ua = navigator.userAgent;
            re = new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})');
            if (re.exec(ua) !== null) rv = parseFloat(RegExp.$1);
        } else if (navigator.appName === 'Netscape') {
            ua = navigator.userAgent;
            re = new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})');
            if (re.exec(ua) !== null) rv = parseFloat(RegExp.$1);
        }
        return rv
    }

    getForcedMobileWidth() {
        if(this.props.forceMobileWidth && window.innerWidth < this.props.forceMobileWidth) return true;
        return false;
    }
    
    renderGif() {
        const { name } = this.props;
        return (
            <LazyLoad height={550}>
                <img
                    className="MobileWrapper__image"
                    alt={name}
                    src={i18n.t(`${namespaceMap[name]}:fallbackGif`)}
                />
            </LazyLoad>
        )
    }

    isGifRequired() {
        return this.state.isGif;
    }

    renderDesktop() {
        return this.props.children;
    }

    render() {
        const IEVersion = this.getInternetExplorerVersion()
        const isMobile = md.mobile() || IEVersion === 11 || this.getForcedMobileWidth() || this.isGifRequired()

        return (
            <div className="MobileWrapper">
                {isMobile ? this.renderGif() : this.renderDesktop()}
            </div>
        )
    }
}

export default MobileWrapper;
